import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-layout-wrapper gfu-layout-wrapper--narrow _mb-6 js-main-content" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_project_navigation = _resolveComponent("project-navigation")
  const _component_comments_section = _resolveComponent("comments-section")

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { id: "navigation" }, null, -1 /* CACHED */)),
    _createVNode(_component_project_navigation, {
      items: $props.navigation.items
    }, null, 8 /* PROPS */, ["items"]),
    _createElementVNode("main", _hoisted_1, [
      _createVNode(_component_comments_section, {
        "allow-creator-hiding-comments": $props.allowCreatorHidingComments,
        "comment-thread-i-d": $props.commentThreadID,
        "hide-comments-on-mobile": $props.hideCommentsOnMobile,
        tag: $props.tag,
        "tag-redirect-url": $props.tagRedirectUrl,
        "show-recommendations": $props.showRecommendations,
        "show-streams": $props.showStreams,
        layout: $props.layout,
        loading: $props.loading,
        "can-comment": $props.canComment
      }, null, 8 /* PROPS */, ["allow-creator-hiding-comments", "comment-thread-i-d", "hide-comments-on-mobile", "tag", "tag-redirect-url", "show-recommendations", "show-streams", "layout", "loading", "can-comment"])
    ])
  ]))
}